export default __webpack_public_path__ + "static/media/zohan.c00760e0.png";